import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-upload-sign-docs-sidepanel',
  templateUrl: './upload-sign-docs-sidepanel.component.html',
  styleUrls: ['./upload-sign-docs-sidepanel.component.scss']
})
export class UploadSignDocsSidepanelComponent implements OnInit {

  @Input() modalInputs = {
    isInitialSign: true,
    issue: null,
    user: null,
    shouldMakeTransition: true,
    signatoriesList: [],
    documents: []
  };
  @Input() isShown = false;
  @Output() sidebarStateChange = new EventEmitter(false);
  repeatedSignatories = [];

  constructor() { }

  ngOnInit() {
    this.repeatedSignatories = [];
  }

  /**
   * when cancel or close sidepanel is clicked, emit a boolean on sidebarStateChange event
   * @param action optional boolean flag
   */
  onSignUploadCancel(action) {
    this.isShown = false;
    this.sidebarStateChange.emit(action);
  }

  /**
 * Handler for the remove selected signatory action of the ngselect control
 * @param signatoryId the signatory to remove form the repeat signatory list
 */
  removeDocSignatory(signatoryId) {
    this.repeatedSignatories = this.repeatedSignatories.
      filter(value => value.id !== signatoryId);
  }
}
